import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { ContainerBase, Paragraph } from "./style/SingleNotificationStyle";
import { useTranslation } from "react-i18next";
import { ChecklistReportType, ChecklistSubitemReport } from "../../service/Reports";
import { useMutation, useQuery } from "@tanstack/react-query";
import AttToken from "../../helpers/attToken";
import Tickets, { novaMensagem } from "../../service/Tickets";
import ModalDeny from "./ModalDeny";
import { toast } from "react-toastify";
import DeleteIcon from '@mui/icons-material/Delete';
import ModalImagePreview from "../Reports/ModalDetailPrint/ModalImagePreview";
import { AxiosError } from "axios";
import ModalDetailPrint from "../Reports/ModalDetailPrint/ModalDetailPrint";
import ModalImageOnTicket from "./ModalImageOnTicket";
import RedirectModal from "./Modals/RedirectModal";
import {
  Button,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Skeleton,
  Stack,
  TextField,
  ThemeProvider,
  Typography
} from "@mui/material";
import ImagesCmp from "../ImagesCmp";
import { ItemChecklist } from "../../service/Checklists";
import { useParams } from "react-router-dom";
import { trackEventMatomo } from "../../helpers/matomo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getMuiTheme } from "../TableHelpers/options";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from 'date-fns/locale/pt-BR';
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CancelIcon from '@mui/icons-material/Cancel';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import QueryFn from "../../helpers/QueryFn";

const ticketsService = new Tickets();
const queryFn = new QueryFn();

export default function SingleNotification({ idModal }: { idModal?: string }) {
  const { t } = useTranslation('translation');

  const idParam = useParams();

  const actualDate = new Date().getTime();

  const { hierarchyLabel, openModal, setPopUp, userData } = useContext(UserContext);

  const [selected, setSelected] = useState<ChecklistReportType>();
  const [openImg, setOpenImg] = useState(false);
  const [imgChamado, setImgChamado] = useState('');
  const handleOpen = () => setOpenImg(true);
  const handleClose = () => {
    setOpenImg(false);
    setImgChamado('');
  };
  const [image, setImage] = useState<string>('');
  const [open, setOpen] = useState(false);
  const [openModalPrint, setOpenModalPrint] = useState(false);
  const [openRefuse, setOpenRefuse] = useState(false);
  const [openImgPreview, setOpenImgPreview] = useState(false);
  const [openRedirect, setOpenRedirect] = useState(false);
  const [imgPreview] = useState('');
  const [objectStatus, setObjectStatus] = useState<novaMensagem>({
    comentario: '',
    dataAcompanhamento: new Date(actualDate - (actualDate % 86400000) + 10800000),
    status: 'emandamento',
    referenciaFoto: ''
  });
  const [disable, setDisable] = useState(false);

  const { data, isLoading, isFetching, refetch, isError } = queryFn.useFetch('TicketById',
    async () => {
      const token = await AttToken();
      if (token) {
        let idApi = '';
        if (window.location.pathname.includes('/detalheChamado/')) {
          idApi = idParam.id as string;
        } else {
          idApi = idModal as string;
        }
        const response = await ticketsService.getTicketById(token, idApi);
        return response;
      }
    });

  if (isError) {
    toast.error(t('notifications.errorFetchingNotifications') as string);
  }

  const item = data?.execucaoChecklist?.itens?.filter((item: ItemChecklist) => item.id === data.itemId)[0];
  const subitem: any = data?.execucaoChecklist?.itens?.find((item: ItemChecklist) => item.id === data.itemId)
    ?.subitens?.filter((subItem: any) => subItem.id === data?.subitemId)[0] as unknown as ChecklistSubitemReport;

  useEffect(() => {
    if (data) {
      setSelected(data.execucaoChecklist);
    }
  }, [data]);

  const verificaResponsavel = () => {
    if (data.responsavelNome && data.responsavelNome !== userData.userName) {
      return false;
    } else return true;
  };

  const closeAndAtt = async () => {
    setOpen(false);
  };

  const closeImgPreview = async () => {
    setOpenImgPreview(false);
  };

  const closeRedirectModal = async () => {
    setOpenRedirect(false);
  };

  const onHandleClick = () => {
    setPopUp(true);
    setOpenModalPrint(true);
  };


  const { mutate: remove, isSuccess: successUpdate } = queryFn.useMutate('UpdateStatusChamado',
    async (value: string) => {
      setDisable(true);
      const token = await AttToken();
      if (token && idParam) {
        const novaMensagemObj: novaMensagem = {
          comentario: objectStatus.comentario,
          dataAcompanhamento: objectStatus.dataAcompanhamento,
          status: value,
          referenciaFoto: image,
        };
        let idApi = '';
        if (window.location.pathname.includes('/detalheChamado/')) {
          idApi = idParam.id as string;
        } else {
          idApi = idModal as string;
        }
        const response = await ticketsService.update(token, idApi, { novaMensagem: novaMensagemObj });
        toast.warn(`${t('notifications.ticket.tickets')} ${objectStatus.status === 'recusado'
          ? `${t('notifications.ticket.refused')}`
          : `${t('notifications.ticket.canceled')}`}`);
        openModal(false);
        refetch();
        return response;
      }
    });

  if (successUpdate) {
    setDisable(false);
  }

  const renderSwitch = (param: ChecklistSubitemReport) => {
    switch (param.tipo) {
      case 'multiple': case 'unique':
        return (
          <>
            {param.selecao ? param.selecao.map((e, i) => {
              if ((param.selecionados && param.selecionados[i])) {
                return (<li key={i} style={{
                  fontWeight: `${(param.selecionados && param.selecionados[i]) ? '900' : '250'}`,
                  marginLeft: `${(param.selecionados && param.selecionados[i]) ? '30px' : '2px'}`
                }}>
                  {e}
                </li>);
              } else return <></>;
            }) : <li>a</li>}
            {param.img && (
              <ImagesCmp images={param.img} selected={selected as ChecklistReportType} />
            )}
            {param.ocorrencia && <p>{`${t('Filling.occurrence')} ${param.ocorrencia}`}</p>}
          </>
        );

      case 'avaliacao':
        return (
          param.avaliacao && param.avaliacao.map((ele, i) => (
            <>
              <ol
                style={{
                  fontWeight: `${(param.avaliacao && param.avaliacao[i].valor === param.nota) ? '900' : '250'}`
                }}
              >{ele.valor} - {ele.nome}
              </ol>
            </>
          )
          )
        );

      case 'list':
        return (
          <>
            {param.padraoLista ? param.padraoLista.map((e, i) => {
              if ((param.selecionados && param.selecionados[i].texto === e)) {
                return (<li key={i} style={{
                  fontWeight: `${(param.selecionados && param.selecionados[i].texto === e) ? '900' : '250'}`,
                  marginLeft: `${(param.selecionados && param.selecionados[i].texto === e) ? '30px' : '2px'}`
                }}>
                  {e}
                </li>);
              } else return <></>;
            }) : <li>a</li>}
            {param.ocorrencia && <p>{`${t('Filling.response')} ${param.ocorrencia}`}</p>}
            {param.img && (
              <ImagesCmp images={param.img} selected={selected as ChecklistReportType} />
            )}
          </>
        );

      case 'data': case 'hora': case 'assinatura': case 'email': case 'telefone': case 'rg': case 'cpfcnpj': case 'cep': case 'placa':
        return (
          <>
            {param.ocorrencia && <p>{`${t('Filling.response')} ${param.ocorrencia}`}</p>}
            {param.img && (
              <ImagesCmp images={param.img} selected={selected as ChecklistReportType} />
            )}
          </>
        );

      default:
        return (
          <div>
            {param.ocorrencia && <li>{`${t('Filling.response')} ${param.ocorrencia}`}</li>}
            {param.img && (
              <ImagesCmp images={param.img} selected={selected as ChecklistReportType} />
            )}
          </div>
        );
    }
  };

  const { mutate: accept } = queryFn.useMutate('UpdateStatusChamado',
    async (value: string) => {
      setDisable(true);
      const token = await AttToken();
      if (token && idParam) {
        const novaMensagemObj: novaMensagem = {
          comentario: objectStatus.comentario,
          dataAcompanhamento: objectStatus.dataAcompanhamento,
          status: value,
          referenciaFoto: image,
        };
        let idApi = '';
        if (window.location.pathname.includes('/detalheChamado/')) {
          idApi = idParam.id as string;
        } else {
          idApi = idModal as string;
        }
        const response = await ticketsService.update(token, idApi, { novaMensagem: novaMensagemObj });
        toast.warn(`${t('notifications.ticket.tickets')} ${objectStatus.status === 'emandamento' ? t('Filling.inProgress') : t('Filling.completed')}`);
        setImage('');
        refetch();
        setDisable(false);
        return response;
      }
    });

  function getBase64(file: File, cb: (s: string) => void) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      cb(reader.result as string);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const renderImages = (File: FileList | null) => {
    if (File) {
      Array.from(File).map(e => getBase64(e, (i) => setImage(i)));
    }
  };

  const ModalIamge = ({ image }: { image: string }) => {
    return (
      <Modal
        open={openImg}
        onClose={handleClose}
      >
        <Stack
          height='100%'
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <IconButton
              sx={{ position: 'absolute' }}
              onClick={() => handleClose()}
            >
              <CancelIcon color="error" />
            </IconButton>
            <img alt='' src={image} style={{ maxWidth: '400px' }} />
          </Stack>
        </Stack>
      </Modal>
    );
  };

  const getStatus = (value: string) => {
    switch (value) {
      case 'emandamento':
      case 'cancelado':
      case 'concluido':
        return (
          data.historicoChamado ? Object.keys(data.historicoChamado)?.map((e) => (
            <>
              <Stack
                sx={{ paddingLeft: '15px', paddingRight: '15px' }}
                width='100%'
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                spacing={2}
              >
                <Stack
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={1}
                >
                  <span style={{ paddingLeft: '20px' }}>
                    <Typography variant="h5" sx={{ marginBottom: '10px' }}>
                      {(data?.historicoChamado as any)[e].nomeUsuarioAcompanhamento || ''}
                    </Typography>
                    <p style={{ fontSize: '15px' }}>
                      <Typography variant='caption' fontWeight={600} fontSize='medium'>{t('notifications.ticket.Data_de _atendimento')}: </Typography>
                      {typeof (data?.historicoChamado as any)[e].data === 'number'
                        ? new Date((data?.historicoChamado as any)[e].data).toLocaleString('pt-BR')
                        : (data?.historicoChamado as any)[e].data || '-'}
                    </p>
                    <p style={{ fontSize: '15px' }}>
                      <Typography variant='caption' fontWeight={600} fontSize='medium'>{t('notifications.ticket.Comentario')}: </Typography>
                      {(data?.historicoChamado as any)[e].comentario || '-'}
                    </p>
                    <p style={{ fontSize: '15px' }}>
                      <Typography variant='caption' fontSize='medium' fontWeight={600}>{t('status')}: </Typography>
                      {(data?.historicoChamado as any)[e].statusTraduzido || '-'}
                    </p>
                  </span>
                  <Typography variant='subtitle2' fontSize={'12px'}>
                    Atualizado em: {typeof (data?.historicoChamado as any)[e].dataMensagem === 'number'
                      ? new Date((data?.historicoChamado as any)[e].dataMensagem).toLocaleString('pt-BR')
                      : (data?.historicoChamado as any)[e].dataMensagem || '-'}
                  </Typography>
                </Stack>
                <img
                  onClick={() => {
                    setImgChamado((data?.historicoChamado as any)[e].foto);
                    handleOpen();
                  }}
                  style={{ maxHeight: '150px' }}
                  height={'150px'}
                  src={(data?.historicoChamado as any)[e].foto || ''}
                  alt=""
                />
              </Stack>
              <Divider sx={{ width: '100%' }} />
            </>
          )) : <span style={{ fontStyle: 'italic' }}>{t('notifications.ticket.chamado_sem_msg')}</span>
        );
      case 'pendente':
        return (
          <span style={{ fontStyle: 'italic' }}>{t('notifications.ticket.chamado_pendente')}</span>
        );
      case 'recusado':
        return (
          <span style={{ fontStyle: 'italic' }}>{t('notifications.ticket.Chamado_recusado')}</span>
        );
      default:
        return (
          <></>
        );
    }
  };

  const tipoExibido = (value: string) => {
    switch (value) {
      case 'avaliacao':
        return '(Avaliação)';
      case 'multiple':
        return '(Multiplo)';
      case 'unique':
        return '(Unico)';
      case 'textoCurto':
        return '(Texto curto)';
      case 'textoLongo':
        return '(Texto longo)';
      case 'list':
        return '(Lista de textos)';
      case 'email':
        return '(E-mail)';
      case 'placa':
        return '(Placa)';
      case 'cpfcnpj':
        return '(CPF / CNPJ)';
      case 'cep':
        return '(CEP)';
      case 'assinatura':
        return '(Assinatura)';
      case 'rg':
        return '(RG)';
      case 'data':
        return '(Data)';
      case 'hora':
        return '(Hora)';
      case 'telefone':
        return '(Telefone)';
      case 'numero':
        return '(Numero)';
      default:
        return (<div>AAAAAAA</div>);
    }
  };

  const Pendente = ({ ticket }: { ticket: any }) => {
    return (
      <Stack
        sx={{ marginTop: '10px', marginBottom: '10px' }}
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        spacing={1}
      >
        <Button
          endIcon={<TaskAltIcon />}
          disabled={ticket?.block}
          onClick={() => {
            accept('emandamento');
          }}
          className="button is-success"
        >
          {t('notifications.ticket.Aceitar')}
        </Button>
        <Button
          endIcon={<DoDisturbIcon />}
          disabled={ticket?.block}
          onClick={() => {
            remove('recusado');
          }}
          className="button is-danger"
        >
          {t('notifications.ticket.Recusar')}
        </Button>
        {ticket.encaminha
          && <Button
            endIcon={<SwapHorizIcon />}
            disabled={ticket?.block}
            onClick={() => setOpenRedirect(true)}
            className="button is-info">
            {t('notifications.ticket.Redirecionar')}
          </Button>}
      </Stack>
    );
  };

  return (
    <>
      <div>
        {openImg && <ModalIamge image={imgChamado} />}
        {openRedirect &&
          <RedirectModal
            openRedirect={openRedirect}
            setOpenRedirect={closeRedirectModal}
            chamadoId={
              window.location.pathname.includes('/detalheChamado/')
                ? idParam.id as string
                : idModal as string
            }
          />}
        {openModalPrint &&
          <ModalDetailPrint
            openModal={openModalPrint}
            setOpenModal={setOpenModalPrint}
            selected={selected as ChecklistReportType} />}
        {openImgPreview &&
          <ModalImageOnTicket
            image={imgPreview}
            open={openImgPreview}
            setOpen={closeImgPreview}
          />}
        {open &&
          <ModalImagePreview
            image={image}
            open={open}
            setOpen={closeAndAtt}
          />}
        {openRefuse && <ModalDeny
          openRefuse={openRefuse}
          setOpenRefuse={setOpenRefuse}
          status={objectStatus.status}
          mutate={remove}
        />}

        {isLoading || isFetching ? (
          <>
            <Skeleton variant="rounded" width={'200px'} height={40} sx={{ marginBottom: '10px' }} />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={0.5}
              >
                <Skeleton variant="rounded" width={300} height={25} sx={{ marginBottom: '10px' }} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
              </Stack>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={0.5}
              >
                <Skeleton variant="rounded" width={300} height={25} sx={{ marginBottom: '10px' }} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={200} />
              </Stack>
            </Stack>
            <Skeleton variant="rounded" height={'200px'} width='100%' sx={{ marginTop: '20px' }} />
          </>
        ) : <>
          <Button
            sx={{ marginBottom: '10px' }}
            endIcon={<FileOpenIcon />}
            className="button is-info"
            onClick={() => {
              trackEventMatomo('modal chamado', 'click', 'button', 'fecha/cancela');
              onHandleClick();
              setDisable(true);
            }}>
            {t('ticketDetail.showForm')}
          </Button>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid width={'50%'}>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Typography variant="h6">Informações do chamado</Typography>
                {/* <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>Nome do chamado </Typography>
                  {ticket?.nome || '-'}
                </p> */}
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.user')} </Typography>
                  {data?.usuarioNome?.startsWith('anonimo') ? 'Anonimo' : data?.usuarioNome}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('notifications.ticket.responsible')} </Typography>
                  {(data?.responsavelNome || '-')}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.dateIn')} </Typography>
                  {new Date(data?.inicio).toLocaleString('pt-BR')}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.dateLimit')} </Typography>
                  <span
                    style={{
                      color: (data)
                        && data?.dataPrevisao > Number(objectStatus?.dataAcompanhamento)
                        ? ''
                        : 'red'
                    }}
                  >
                    {new Date(data?.dataPrevisao).toLocaleString('pt-BR')}
                  </span>
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.message')} </Typography>
                  {data?.instrucao}
                </p>
              </Stack>
            </Grid>
            <Grid width={'50%'}>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Typography variant="h6">Informações do formulário</Typography>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.fromName')} </Typography>
                  {selected
                    ? selected?.formulario
                    : 'Formulário não econtrado, pode não existir ou ainda estar em upload.'}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.initial')} </Typography>
                  {selected && new Date(selected.inicio).toLocaleString('pt-BR')}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.final')} </Typography>
                  {selected && new Date(selected.fim).toLocaleString('pt-BR')}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{t('ticketDetail.manage')} </Typography>
                  {data?.nomeGerencia}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{hierarchyLabel.cliente}: </Typography>
                  {data?.nomeCliente}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{hierarchyLabel.local}: </Typography>
                  {data?.nomeLocal}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{hierarchyLabel.conjunto}: </Typography>
                  {data?.nomeConjunto}
                </p>
                <p style={{ fontSize: '13px' }}>
                  <Typography variant='caption' fontWeight={600}>{hierarchyLabel.unidade}: </Typography>
                  {data?.nomeUnidade}
                </p>
              </Stack>
            </Grid>
          </Stack>
          {data?.itemId
            && <ContainerBase className="columns" style={{ border: '1px solid lightgray', margin: '5px' }}>
              <div className="column" style={{ display: 'flex', flexDirection: 'column' }}>
                <Paragraph>
                  {t('notifications.ticket.item')}&nbsp;
                  <span>
                    {item?.nome}
                  </span>
                </Paragraph>
                <Paragraph>
                  {t('notifications.ticket.Subitem_chamado')}:&nbsp;
                  <span>
                    {subitem?.nome}
                  </span>
                </Paragraph>
                <Paragraph>
                  {t('notifications.ticket.Resposta_subtitem')}:&nbsp;
                  <span>
                    {data?.execucaoChecklist?.itens?.find((item: ItemChecklist) => item.id === data?.itemId)?.subitens.filter((ele: any) => ele.id === data?.subitemId).map((subItem: any) => (
                      <div>
                        <ul>
                          {renderSwitch(subItem as unknown as ChecklistSubitemReport)}
                        </ul>
                      </div>
                    ))}
                  </span>
                </Paragraph>
              </div>
              <div className="column">
                <Paragraph>
                  {t('notifications.ticket.Tipo_subitem')}:&nbsp;
                  <span>
                    {subitem?.tipo ? tipoExibido(subitem?.tipo) : ''}
                  </span>
                </Paragraph>
                <Paragraph>
                  {t('notifications.ticket.Fotos_subitem')}:&nbsp;
                </Paragraph>
                <span>
                  <ImagesCmp images={subitem?.img as string[]} selected={selected as ChecklistReportType} />
                </span>
              </div>
            </ContainerBase>}
          {data?.status === 'pendente' && <Pendente ticket={data} />}
          {data?.historicoChamado && <Typography variant="h6">{t('notifications.ticket.Lista_acoes')}</Typography>}
          {data?.historicoChamado && Object?.keys(data?.historicoChamado as any)?.forEach((key: string) => {
            const ticketObj: any = data?.historicoChamado;
            return (
              ticketObj[key].nomeUsuarioAcompanhamento
            );
          })}
          <Stack
            sx={{ border: '1px solid lightgray', padding: '20px' }}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={0.5}
          >
            {data && getStatus(data?.status)}
          </Stack>
          {data?.status === 'emandamento' &&
            <>
              <Typography variant="h6" textAlign={'center'}>{t('ticketDetail.doAction')}</Typography>
              <Stack
                width={'100%'}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                spacing={1}
              >
                <Stack
                  width='100%'
                  direction="column"
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={1}
                >
                  <ThemeProvider theme={getMuiTheme()}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                      <DesktopDatePicker
                        sx={{ margin: '10px !important' }}
                        format='dd/MM/yyyy'
                        label={t('ticketDetail.dateConclusion')}
                        value={objectStatus.dataAcompanhamento as Date}
                        onChange={(date) => {
                          trackEventMatomo('modal chamado', 'click', 'datepicker', 'edita data');
                          setObjectStatus({ ...objectStatus, dataAcompanhamento: (date?.setHours(23, 59, 59) as number) });
                        }}
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label={t('ticketDetail.comment')}
                    onClick={() => trackEventMatomo('modal chamado', 'click', 'textarea', 'edita valor')}
                    onChange={(e) => setObjectStatus({ ...objectStatus, comentario: e.target.value })}
                    value={objectStatus.comentario}
                  />
                </Stack>
                <Stack
                  width='100%'
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-end"
                  spacing={1}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label"> {t('ticketDetail.action')}</InputLabel>
                    <Select
                      variant='outlined'
                      label={t('ticketDetail.action')}
                      onClick={() => trackEventMatomo('modal chamado', 'click', 'select', 'seleciona valor')}
                      onChange={(e) => setObjectStatus({ ...objectStatus, status: e.target.value as string })}
                    >
                      <MenuItem value={'emandamento'}>{`${t('ticketDetail.proceed')}`}</MenuItem>
                      <MenuItem value={'concluido'} disabled={!verificaResponsavel()}>{`${t('ticketDetail.conclude')}`}</MenuItem>
                      <MenuItem value={'cancelado'}>{`${t('ticketDetail.cancel')}`}</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    endIcon={<CheckCircleOutlineIcon />}
                    disabled={disable || data?.block}
                    onClick={() => {
                      trackEventMatomo('modal chamado', 'click', 'button', 'salva');
                      objectStatus.status === 'recusado'
                        || objectStatus.status === 'cancelado'
                        ? remove(objectStatus.status)
                        : accept(objectStatus.status);
                    }}
                    className="button is-success"
                  >
                    {t('ticketDetail.confirm')}
                  </Button>
                  {!image ? <Button
                    startIcon={<CloudUploadIcon />}
                    style={{
                      width: 'fit-content',
                      backgroundColor: '#643E91',
                      color: '#fff',
                      marginBottom: '10px',
                    }}
                  >
                    {'Upload Imagem'}
                    <input
                      disabled={data?.block}
                      value={''}
                      type="file"
                      id="img"
                      name="img"
                      accept="image/*"
                      className='file-input'
                      multiple={true}
                      onClick={() => trackEventMatomo('modal chamado', 'click', 'input', 'add imagem')}
                      onChange={(e) => renderImages(e.target.files)}
                    />
                  </Button>
                    : <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      spacing={0.5}
                    >
                      <IconButton
                        disabled={data?.block}
                        value={image}
                        onClick={() => {
                          trackEventMatomo('modal chamado', 'click', 'button', 'remove imagem');
                          setImage('');
                        }}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                      <img
                        onClick={() => {
                          trackEventMatomo('modal chamado', 'click', 'img', 'abre imagem');
                          setOpen(true);
                        }}
                        style={{ objectFit: 'cover', width: '150px', maxWidth: '150px' }}
                        alt='foto'
                        src={image}
                        width={100}
                      />

                    </Stack>}
                </Stack>
              </Stack>
              {!verificaResponsavel() && (
                <span className="tag is-warning">
                  {t('notifications.modals.onlyResponsibleCanComplete')}
                  "{data.responsavelNome
                    || `${t('notifications.modals.nameNotFound')}`}"
                  {t('notifications.ticket.canCompleteThisTicket')}</span>
              )}
            </>}
        </>}
      </div>
    </>
  );
}
